<template>
    <div class="footercomponent">
        <div class="page-footer bg-secondary-new d-flex flex-column justify-content-between px-6 pt-4 pb-0" :class="{'zindextoggle':triggerZinde == true, 'changingzindex':triggerZindexes == true}">
            <div class="helpdesk-footer d-md-block hidden-sm-down" :class="{'z-index-footer':$route.path == '/subscription'}">
                <div class="middle-helpdesk">
                    <div class="toolbar row no-gutters align-items-center px-4 px-sm-6 pb-4">
                        <div class="col">
                            <div class="row no-gutters align-items-center">
                                <div class="">
                                    <span class="text-footer pointer" @click="openHelpdesk()">
                                        <img src="/static/images/images-new-theme/icons/help-desk.svg" class="help-desk-image">HelpDesk
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			<div class="row no-gutters align-items-start justify-content-between flex-nowrap tag-line">
				<div class="d-flex align-items-center w-100">
					<div class="text-white fw-500 whiteSpace fs-12 app-version w-20" v-if="prod">App Version(P): V3.3.6</div>
					<div class="text-white fw-500 whiteSpace fs-12 app-version w-20" v-else>App Version(T): v3.1.1</div>
					<div class="contentCenter fw-500 text-align-center w-40">
						<span class="h6 text-footer-down margin-left">© Copyright 2014 - {{ new Date().getFullYear() }}
							<a class="footertext" href="https://www.digicollect.com/" target="_blank">DigiCollect</a> - All Rights Reserved
						</span>
					</div>
				</div>
            </div>
			<div class="d-flex justify-content-end footer-icon-placement">
				<router-link to="/" class="footer-icons pointer" :class="{'z-index-footer':$route.path == '/subscription'}">
					<img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/home.svg" class="mt-1px">
				</router-link>
				<a class="ml-5 footer-icons pointer" :class="{'z-index-footer':$route.path == '/subscription'}">
					<img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/search.svg">
				</a>
				<a class="ml-5 footer-icons pointer" :class="{'z-index-footer':$route.path == '/subscription'}">
					<img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/chat.svg">
				</a>
			</div>
        </div>
    </div>
</template>
<script>
import globals from "./globals";
import { EventBus } from "./eventBus/nav-bar-event.js";
export default {
	data:function() {
        return {
            prod: false,
            triggerZinde:false,
            triggerZindexes:false
        }
    },
    methods:{
        openHelpdesk(){
            if(location.origin.startsWith('http://localhost') || (location.origin == 'http://testcrm.digicollect.com/')){
                window.open('https://testhelpdesk.digicollect.com/','_blank');
            }else if(location.origin == 'https://crm.digicollect.com/'){
                window.open('https://helpdesk.digicollect.com/','_blank');
            }
        },
    },
    mounted() {
        if (globals.CRM_URL == "https://crm.digicollect.com") {
            this.prod = true;
        }
    }
}
</script>
<style scoped>
    .Line-7-Copy {
    	width: 2px;
    	height: 24px;
    	border: solid 1px #e0e3e6;
    }
    span.text-footer-down {
    	font-size: 12px;
    	text-align: center !important;
    	color: #ffffff !important;
		position: relative;
    	top: 8px;
    }
    .footertext {
    	color: #ffffff !important;
    	text-decoration: none !important;
    }
    .page-footer {
    	/* z-index: 9999; */
    	height: 58px;
    }
    .no-gutters .textcenter-footer {
    	text-align: center;
    }
    .bg-secondary-new{
        background: #005dae !important;
    }
    .helpdesk-footer {
    	height: 38px;
    	border-radius: 15px;
    	background-color: #ffffff;
    	border: solid 2px #005dae;
		margin: -35px auto 0;
    }
    .text-footer {
    	font-size: 12px;
    	font-weight: 600;
    	font-style: normal;
    	font-stretch: normal;
    	line-height: 1.42;
    	letter-spacing: normal;
    	color: #4e5764;
    	display: flex;
    	align-items: center;
    	justify-content: center;
    }
    .help-desk-image {
    	width: 17.7px;
    	height: 17.7px;
    	-o-object-fit: contain;
    	object-fit: contain;
    	margin-left: 4px;
    	margin-right: 8px;
    }
    .middle-helpdesk {
    	padding-top: 9px;
    }
    .col-20,
    .col-sm-20,
    .col-md-20,
    .col-lg-20,
    .col-xl-20 {
    	position: relative;
    	width: 100%;
    	min-height: 1px;
    	padding-right: 15px;
    	padding-left: 15px;
    }
    .col-20 {
    	-webkit-box-flex: 0;
    	-webkit-flex: 0 0 20%;
    	-ms-flex: 0 0 20%;
    	flex: 0 0 20%;
    	max-width: 20%;
    }
    @media (min-width: 576px) {
    	.col-sm-20 {
    		-webkit-box-flex: 0;
    		-webkit-flex: 0 0 20%;
    		-ms-flex: 0 0 20%;
    		flex: 0 0 20%;
    		max-width: 20%;
    	}
		.app-version{
			position:relative;top:8px;
		}
    }
    @media (min-width: 768px) {
    	.col-md-20 {
    		-webkit-box-flex: 0;
    		-webkit-flex: 0 0 20%;
    		-ms-flex: 0 0 20%;
    		flex: 0 0 20%;
    		max-width: 20%;
    	}
		.app-version{
			position:relative;top:8px;
		}
    }
    @media (min-width: 992px) {
    	.col-lg-20 {
    		-webkit-box-flex: 0;
    		-webkit-flex: 0 0 20%;
    		-ms-flex: 0 0 20%;
    		flex: 0 0 20%;
    		max-width: 20%;
    	}
		.app-version{
			position:relative;top:8px;
		}
    }
    @media (min-width: 1200px) {
    	.col-xl-20 {
    		-webkit-box-flex: 0;
    		-webkit-flex: 0 0 20%;
    		-ms-flex: 0 0 20%;
    		flex: 0 0 20%;
    		max-width: 20%;
    	}
		.app-version{
			position:relative;top:8px;
		}
    }
	.footer-icons{
		position:relative;
		bottom:37px;
		cursor: pointer;
	}
	.footer-icons img{
		width: 36px;
	}
	.tag-line{
		position: relative;
	}
	.z-index-footer{
		z-index: 1;
	}
	@media screen and (min-width: 571px) {
		.footer-icon-placement{
			position: relative;
			bottom: 20px;
		}

	}
	@media screen and (min-width: 0px) and (max-width:570px) {
		.page-footer {
			height: 100%;
		}
		.text-footer-down{
			top: 16px !important;
			left: 21px;
		}
		.app-version{
			position:relative;
			top: 6px;
		}
		.footer-icon-placement{
			top: -45px !important;
			/* left:260px !important; */
			position: relative !important;
		}
		/* .contentCenter{
			top: -13px;
		} */
     }
	 @media screen and (min-width: 678px) {
		.footer-text{
			display: flex !important;
		}

	}
	@media screen and (max-width: 677px) {
		.footer-text{
			display: block !important;
    		margin-top: -11px !important;
		}

	}
	@media screen and (max-width: 570px) {
		.footer-text{
			display: block !important;
    		margin-top: 10px !important;
		}
		.margin-left{
			margin-left: -20px !important;
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/Footerr.vue